module.exports = __webpack_public_path__ + "media/newstyle/images/pix-6879553e6a77bfbf507b827096a691dc.png";